/**
 * Employees service exports
 * Uses centralized ServiceFactory for dependency injection
 */

import { ServiceFactory } from "../ServiceFactory";

// Export the abstraction, not the implementation
export const employeesService = ServiceFactory.getEmployeesService();

// Export implementations and types for consumers
export { EmployeesService } from "./EmployeesService";
export type {
  EmployeeSearchOptions,
  EmployeeSearchParameters,
  GetEmployeesWithAvailableSlotsParams,
  IEmployeesService,
} from "./IEmployeesService";
